import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LordIcon from '../components/LordIcon';
import LORDICONS from '../lordicons';

type Props = {
  open: boolean;
  isLast: boolean;
  nextTitle: string;
  onContinue: () => void;
  onDiscover: () => void;
  onFinish: () => void;
};

const ContinueGate: React.FC<Props> = ({
  open,
  isLast,
  nextTitle,
  onContinue,
  onDiscover,
  onFinish,
}) => {
  const { t } = useLanguage();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="surface-card surface-card-padded max-w-md w-full shadow-lg">
        <div className="flex items-center gap-2 mb-2">
          <LordIcon src={LORDICONS.check} trigger="in" size={22} color="#0065F4" />
          <h2 className="text-base font-semibold text-gray-900">
            {isLast ? t('tour.gate.last.title') : t('tour.gate.title')}
          </h2>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed mb-5">
          {isLast
            ? t('tour.gate.last.body')
            : t('tour.gate.body', { page: nextTitle })}
        </p>
        <div className="flex flex-col sm:flex-row gap-2 sm:justify-end">
          {!isLast && (
            <button
              type="button"
              onClick={onDiscover}
              className="px-4 py-2 rounded-xl border border-gray-200 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              {t('tour.gate.discover')}
            </button>
          )}
          <button
            type="button"
            onClick={isLast ? onFinish : onContinue}
            className="px-4 py-2 rounded-xl bg-primary-600 text-white text-sm font-semibold hover:bg-primary-700"
          >
            {isLast ? t('tour.finish.cta') : t('tour.gate.continue')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContinueGate;
